import React from 'react';

//import icons
// import { BiHomeAlt, BiUser } from 'react-icons/bi';
// import { BsBriefcase, BsChatSquare, BsClipboardData } from 'react-icons/bs';
import { TiUser } from 'react-icons/ti';
// import { BsLaptopFill } from 'react-icons/bs';
import { HiHome, HiViewGrid } from 'react-icons/hi';
import { HiChatBubbleBottomCenter } from 'react-icons/hi2';

//import images
// import Square from '../assets/Square.svg';
// import Triangle from '../assets/Triangle.svg';
// import Circle from '../assets/Circle.svg';
// import Hexagon from '../assets/Hexagon.svg';
// import Ellipse from '../assets/Ellipse.svg';

//link
import { Link } from 'react-scroll';

const Nav = () => {
  return (
    <nav className='fixed bottom-3 lg:bottom-8 w-full overflow-hidden z-50'>
      <div className='container mx-auto'>
        {/* navbar inner */}
        <div className='w-full bg-black/20 h-[60px] lg:h-[70px] backdrop-blur-2xl rounded-full max-w-[450px] mx-auto px-1 lg:px-1 flex justify-around items-center text-2xl text-white/50'>
          <Link to='home' activeClass='active' smooth={true} spy={true} offset={-200} className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center'>
            {/* <img src={Square} alt="Square" className='lg:w-[30px] lg:h-[30px] w-[20px] h-[20px]' /> */}
            <HiHome className='lg:w-[30px] lg:h-[30px] w-[27px] h-[27px]' />
          </Link>
          <Link to='about' activeClass='active' smooth={true} spy={true} className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center'>
            {/* <img src={Triangle} alt="Triangle" className='lg:w-[30px] lg:h-[30px] w-[20px] h-[20px]' /> */}
            <TiUser className='lg:w-[35px] lg:h-[35px] w-[30px] h-[30px]' />
          </Link>
          {/* <Link to='services' activeClass='active' smooth={true} spy={true} className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center'>
            <img src={Circle} alt="Circle" className='lg:w-[30px] lg:h-[30px] w-[20px] h-[20px]' />
            <HiCube className='lg:w-[30px] lg:h-[30px] w-[27px] h-[27px]' />
          </Link> */}
          <Link to='work' activeClass='active' smooth={true} spy={true} className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center'>
            {/* <img src={Hexagon} alt="Hexagon" className='lg:w-[30px] lg:h-[30px] w-[20px] h-[20px]' /> */}
            <HiViewGrid className='lg:w-[35px] lg:h-[35px] w-[30px] h-[30px]' />
          </Link>
          <Link to='contact' activeClass='active' smooth={true} spy={true} className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center'>
            {/* <img src={Ellipse} alt="Ellipse" className='lg:w-[30px] lg:h-[30px] w-[20px] h-[20px]' /> */}
            <HiChatBubbleBottomCenter className='lg:w-[30px] lg:h-[30px] w-[27px] h-[27px]' />
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
